import { BASIC_OBJECT_CATEGORIES, countBasicObjects } from '../lib/basicObjectExtraction'
import styles from './BasicObjectSummary.module.css'

interface BasicObjectSummaryProps {
  types: readonly string[]
  candidates?: boolean
}

export default function BasicObjectSummary({ types, candidates = false }: BasicObjectSummaryProps) {
  const counts = countBasicObjects(types)
  return (
    <dl className={styles.summary} aria-label={candidates ? '선택한 기본 객체 레이어' : '기본 객체 추출 결과'}>
      {BASIC_OBJECT_CATEGORIES.map(({ key, label }) => (
        <div key={key}>
          <dt>{label}</dt>
          <dd>
            {counts[key] > 0
              ? `${counts[key].toLocaleString()}${candidates ? '개 레이어' : '개'}`
              : candidates
                ? '선택 없음'
                : '미추출'}
          </dd>
        </div>
      ))}
    </dl>
  )
}
